import React, {useState} from "react";
import { Container, Form, Row, Col, Button, Image } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import QRCode from "react-qr-code";

import {
  IPayloadProps,
  PayloadSubjectUtils,
} from "../../../../../components/multistep/IPayloadProps";

const PaymentDetails = (props: IPayloadProps) => {
  // const subjects = new PayloadSubjectUtils();
  const [paid, setPaid] = useState(false);
  const [qrUrl, setQrUrl] = useState("");

  const agentbaseUrl = process.env.REACT_APP_BACKEND_BASE_URI;

  const getVCRequestUrl = async (credType: any, params: any) =>  {
        
    let response = await fetch(agentbaseUrl + "/webapp/definitions/" + credType + "/auth-requests", {
        method: "POST",
        mode: 'cors',
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json"
        }
      });
      let responseJson = await response.json();
      
      let qrUri = "";
      if (params){
        qrUri = responseJson.authRequestURI + "%3Fmerchant%3D"+ params.merchant +"%26amount%3D"+ params.amount +"%26currency%3D" + params.currency;
      } else {
        qrUri = responseJson.authRequestURI;
      }

      setQrUrl(qrUri);

      waitForResponse(responseJson.correlationId, responseJson.definitionId);     
 }
const waitForResponse = async(correlationId:any, definitionId:any) => {
    let response = await fetch(agentbaseUrl + "/webapp/auth-status", {
        method: "POST",
        mode: 'cors',
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json"
        },
        body: '{"correlationId":"' + correlationId + '","definitionId":"'+ definitionId +'"}'
      });
      let responseJson = await response.json();
      let status = responseJson.status;
      switch(status){
        case "verified":
            setPaid(true);
            break;
        default:
            setTimeout(() => waitForResponse(correlationId, definitionId), 2000);
            break;
      }
}

  if (paid){
    return (
<Container
      fluid
      className="d-flex justify-content-center align-items-center"
    ><h3>Thank you for your payment!</h3></Container>
    );
  }
else {
  return (
    <Container
      fluid
      className="d-flex justify-content-center align-items-center"
    >
      <Row style={{ paddingTop: "70px", marginLeft: "50px" }}>
        <div id="paymentInfoAmount" style={{display: "none"}}>35</div>
        <div id="paymentInfoCurrency" style={{display: "none"}}>$</div>
        <div id="paymentInfoMerchant" style={{display: "none"}}>Demo MNO AG</div>
      <Col className="col-lg-4 col-md-4 col-sm-4" >
              <div
                className="pricing-item mb-30"
                style={{
                  border:"2px solid red",
                  cursor: "pointer",
                }}
              >
                <Row className="pricing-thumb">
                  <Col className="flex-column justify-content-center align-items-center text-left">
                    <h3 className="title">20 GB</h3>
                    <h5 className="sub-title">Internet</h5>
                  </Col>
                </Row>
                <div className="pricing-content">
                  <ul className="pricing-list">
                    <li>Unlimited Calls</li>
                    <li>1000 SMS</li>
                  </ul>
                  <div className="price-wrap">
                    <span> Start From </span>
                    <h3 className="price">
                      $35<sub>/Month</sub>
                    </h3>
                  </div>
                </div>
              </div>
            </Col>
            <Col className="col-lg-8 col-md-8 col-sm-8">
            <Accordion  style={{width: "535px"}}>
            <Card>
              <Card.Header className="pull-left">
                <Accordion.Toggle
                  as={Button}
                  onClick={() => {
                    getVCRequestUrl("CardCredential", {
                      merchant: "MNO Demo AG",
                      amount: "35",
                      currency: "$"
                  })
                  }}
                  variant="link"
                  eventKey="0"
                >
                  Fast Card Payment
                </Accordion.Toggle>
              </Card.Header>
              <Accordion.Collapse eventKey="0">
                <Card.Body>
                  <h3>
                    Please scan the following code with your SSI enabled wallet
                  </h3>
                  <br></br>
                  <QRCode  value={"asdasdasdasdasdsafadgreger"}/>
                  <br></br>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            <Card>
              <Card.Header className="pull-left">
                <Accordion.Toggle
                  as={Button}
                  onClick={() => {
                    getVCRequestUrl("AccountCredential", {
                      merchant: "MNO Demo AG",
                      amount: "35",
                      currency: "$"
                  })
                  }}
                  variant="link"
                  eventKey="1"
                >
                  Account Payment
                </Accordion.Toggle>
              </Card.Header>
              <Accordion.Collapse eventKey="1">
                <Card.Body>
                  <h3>
                    Please scan the following code with your SSI enabled wallet
                  </h3>
                  <br></br>
                  <QRCode  value={"asdasdasdasdasdsafadgreger"}/>
                  <br></br>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            <Card>
              <Card.Header>
                <Accordion.Toggle as={Button} variant="link" eventKey="3">
                  Credit Card
                </Accordion.Toggle>
              </Card.Header>
              <Accordion.Collapse eventKey="3">
                <Card.Body>
                <Form
        style={{
          width: "500px",
          padding: "40px",
          border: "1px solid #ccc",
          borderRadius: "8px",
        }}
        onSubmit={(e) => {e.stopPropagation(); e.preventDefault(); setPaid(true);}}
      >
        <h3>Please add your card information</h3>
        <Form.Group as={Row} controlId="formCardNumber" className="py-3">
          <Form.Label column sm={12} style={{ textAlign: "left" }}>
            Card Number
          </Form.Label>
          <Col sm={12}>
            <Form.Control type="text" name="cc-number" />
          </Col>
        </Form.Group>

        <Form.Group as={Row} controlId="formCardName" className="py-3">
          <Form.Label column sm={12} style={{ textAlign: "left" }}>
            Name on Card
          </Form.Label>
          <Col sm={12}>
            <Form.Control type="text" name="cc-name" />
          </Col>
        </Form.Group>

        <Form.Group as={Row} controlId="formExpiryDate" className="py-3">
          <Form.Label column sm={12} style={{ textAlign: "left" }}>
            Expiry Month
          </Form.Label>
          <Col sm={12}>
            <Form.Control
              as="select"
              type="text"
              name="cc-exp-month"
              placeholder="MM"
            >
              <option>1</option>
              <option>2</option>
              <option>3</option>
              <option>4</option>
              <option>5</option>
              <option>6</option>
              <option>7</option>
              <option>8</option>
              <option>9</option>
              <option>10</option>
              <option>11</option>
              <option>12</option>
            </Form.Control>
          </Col>
        </Form.Group>
        <Form.Group as={Row} controlId="formExpiryDate" className="py-3">
          <Form.Label column sm={12} style={{ textAlign: "left" }}>
            Expiry Year
          </Form.Label>
          <Col sm={12}>
            <Form.Control
              as="select"
              type="text"
              name="cc-exp-year"
              placeholder="YYYY"
            >
              <option>2024</option>
              <option>2025</option>
              <option>2026</option>
              <option>2027</option>
              <option>2028</option>
              <option>2029</option>
              <option>2030</option>
            </Form.Control>
          </Col>
        </Form.Group>

        <Form.Group as={Row} controlId="formCVV" className="py-3">
          <Form.Label column sm={12} style={{ textAlign: "left" }}>
            CVV
          </Form.Label>
          <Col sm={12}>
            <Form.Control type="text" name="cc-csc" />
            <button type="submit" style={{width: "100px", marginTop: "20px", backgroundColor: "rgb(223, 14, 14)", borderColor: "rgb(223, 14, 14)", borderRadius: "4px"}} >Pay</button>
          </Col>
          
        </Form.Group>
        
      </Form>

                </Card.Body>
              </Accordion.Collapse>
            </Card>
          </Accordion>
          
      </Col>
          </Row>
    </Container>
  );
}
};

export default PaymentDetails;
